import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqn } from '@/shared/lib/format';

import type { TagDetail } from '@/entities/tags';

export const getTagDetailApi = async (tagName: string): Promise<TagDetail> => {
  const encodedFqn = encodeOpenMetadataFqn(tagName);
  const { data } = await openMetadataApiClient.get<TagDetail>(`/tags/name/${encodedFqn}`, {
    params: {
      fields: 'domains,owners',
      include: 'all',
    },
  });
  return data;
};
